import { platform } from 'utils/index';
export default function openXYApp() {
  const url = 'xylink://';
  const plat = platform();
  let timeout: NodeJS.Timeout | null = null;
  let checkStatus = 'launch_failed';
  // let hasApp = true;

  if (document.addEventListener) {
    document.addEventListener('visibilitychange', function (e) {
      if (document.visibilityState === 'hidden' && timeout) {
        clearTimeout(timeout);
      }
    });
  }

  window.onblur = function () {
    // hasApp = true;
    checkStatus = 'launch_onblur';
    if (timeout) {
      clearTimeout(timeout);
    }
  };

  window.onfocus = function () {
    console.log('onfocus is fired');
  };

  const startTime = Date.now();

  if (plat.mobile) {
    if (plat.ios) {
      openAppByHref(url);
    } else {
      openAppByIframe(url);
    }
  } else {
    if (plat.webKit) {
      if (plat.chrome) {
        openAppByHref(url);
      } else {
        openAppByIframe(url);
      }
    } else {
      openAppByIframe(url);
    }
  }

  timeout = setTimeout(function () {
    const nowTime = new Date().getTime();
    const waitTime = nowTime - startTime;
    console.log('waitTime is --> ', waitTime);
    if (checkStatus === 'launch_onblur') {
      return false;
    }
    if (waitTime < 2000) {
      // hasApp = false;
    }
  }, 1000);
}

// 打开App通过iframe的方式
function openAppByIframe(scheme: string) {
  const page = document.createElement('iframe');
  page.setAttribute('src', scheme);
  page.setAttribute('style', 'display:none');
  document.body.appendChild(page);
}

// 打开App通过href的方式
function openAppByHref(scheme: string) {
  window.location.href = 'itms-apps://itunes.apple.com/app/id1058254032';
}
